import { Analytics as VercelAnalytics } from "@vercel/analytics/react";
import type { AppProps } from "next/app";
import type { FC, PropsWithChildren } from "react";

import { ThemeProvider } from "@moment/design-system";
import { ConfirmDialogWrapper } from "@moment/ui";

import { AuthProvider } from "~/auth/AuthProvider";
import { isDesktopAppMode } from "~/auth/interop/common";
import { TrackPageView } from "~/components/analytics/TrackPageView";
import { TopBarProvider } from "~/components/topbar/TopBarContext";

import { PropertiesPaneProvider } from "./components/canvas/easel/properties-pane/PropertiesPaneProvider";
import { OutdatedAppModalWrapper } from "./components/outdated-app/OutdatedAppModalContext";
import { AppActorProvider } from "./state/machines/app/AppActorProvider";

export const Providers: FC<
	PropsWithChildren<{
		pageProps?: AppProps["pageProps"];
	}>
> = ({ children, pageProps }) => (
	<AppActorProvider pageProps={pageProps}>
		<AuthProvider>
			{!isDesktopAppMode() && <VercelAnalytics />}
			<TrackPageView />
			{/* ThemeProvider must be above PersistGate to render on the server */}
			<ThemeProvider>
				<TopBarProvider>
					<PropertiesPaneProvider>
						<ConfirmDialogWrapper>
							<OutdatedAppModalWrapper>{children}</OutdatedAppModalWrapper>
						</ConfirmDialogWrapper>
					</PropertiesPaneProvider>
				</TopBarProvider>
			</ThemeProvider>
		</AuthProvider>
	</AppActorProvider>
);
